import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ReqResService } from '../../service/req-res.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

declare var toastr: any;

@Component({
  selector: 'app-reportitem',
  templateUrl: './reportitem.component.html',
  styleUrls: ['./reportitem.component.css']
})
export class ReportitemComponent implements OnInit {
  reportData: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];

  isLoading = false;
  begDate: string = '';
  endDate: string = '';
  statusId: number = 0;
  searchText: string = '';

  currentPage = 1;
  pageSize = 25;

  statusObj: any[] = [];

  constructor(
    private reqRes: ReqResService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Item Report');
  }

  ngOnInit(): void {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    this.begDate = this.formatDate(firstDay);
    this.endDate = this.formatDate(today);
    this.loadStatus();
  }

  loadStatus(): void {
    this.reqRes.getData(`/Report/GetSpecode/ORDER_STATUS`).subscribe(
      (res: any) => {
        const result = Array.isArray(res) ? res : [];
        this.statusObj = result;
        this.loadReport();
      },
      error => {
        console.log(error);
        this.isLoading = false;
        toastr.error('Status yüklənmədi');
      }
    );
  }

  loadReport(): void {
    this.isLoading = true;

    this.reqRes.getData(`/Report/GetEachReport?beg=${this.begDate}&end=${this.endDate}&status=${this.statusId}`).subscribe(
      (res: any) => {
        console.log('REPORT RES', res);

        const result = Array.isArray(res) ? res : [];

        this.reportData = result.map((x: any) => ({
          itemId: x.ItemId,
          itemCode: x.ItemCode,
          itemName: x.ItemName,
          userName: x.UserName,
          segment1: x.Segment1,
          segment2: x.Segment2,
          segment3: x.Segment3,
          totalQty: Number(x.TotalQty || 0),
          totalPrice: Number(x.TotalPrice || 0)
        }));

        this.currentPage = 1;
        this.applyFilter();
        this.isLoading = false;
      },
      error => {
        console.log(error);
        this.isLoading = false;
        this.reportData = [];
        this.filteredData = [];
        this.pagedData = [];
        toastr.error('Report yüklənmədi');
      }
    );
  }

  applyFilter(): void {
    const txt = (this.searchText || '').toLowerCase().trim();

    this.filteredData = this.reportData.filter(x =>
      !txt ||
      (x.itemCode || '').toLowerCase().includes(txt) ||
      (x.itemName || '').toLowerCase().includes(txt) ||
      (x.userName || '').toLowerCase().includes(txt) ||
      (x.segment1 || '').toLowerCase().includes(txt) ||
      (x.segment2 || '').toLowerCase().includes(txt) ||
      (x.segment3 || '').toLowerCase().includes(txt)
    );

    this.setPagedData();
  }

  setPagedData(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedData = this.filteredData.slice(start, end);
  }

  onSearchChange(): void {
    this.currentPage = 1;
    this.applyFilter();
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.setPagedData();
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.pageSize) || 1;
  }

  get pages(): number[] {
    return Array(this.totalPages).fill(0).map((_, i) => i + 1);
  }

  get totalQty(): number {
    return this.filteredData.reduce((sum, x) => sum + Number(x.totalQty || 0), 0);
  }

  get totalPrice(): number {
    return this.filteredData.reduce((sum, x) => sum + Number(x.totalPrice || 0), 0);
  }

  exportToExcel(): void {
    if (!this.filteredData || this.filteredData.length === 0) {
      toastr.warning('Export üçün data yoxdur');
      return;
    }

    const excelData = this.filteredData.map((item, index) => ({
      '#': index + 1,
      'Item Code': item.itemCode,
      'Item Name': item.itemName,
      'User': item.userName,
      'Segment Level 1': item.segment1,
      'Segment Level 2': item.segment2,
      'Segment Level 3': item.segment3,
      'Qty': item.totalQty,
      'Price ($)': item.totalPrice
    }));

    excelData.push({
      '#': null,
      'Item Code': '',
      'Item Name': '',
      'User': '',
      'Segment Level 1': '',
      'Segment Level 2': '',
      'Segment Level 3': 'TOTAL',
      'Qty': this.totalQty,
      'Price ($)': this.totalPrice
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

    worksheet['!cols'] = [
      { wch: 6 },
      { wch: 15 },
      { wch: 35 },
      { wch: 25 },
      { wch: 30 },
      { wch: 10 },
      { wch: 14 }
    ];

    const workbook: XLSX.WorkBook = {
      Sheets: { 'Item Report': worksheet },
      SheetNames: ['Item Report']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    this.saveExcelFile(excelBuffer);
  }

  saveExcelFile(buffer: any): void {
    const data: Blob = new Blob(
      [buffer],
      {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      }
    );

    const fileName = `Item_Report_${this.begDate}_to_${this.endDate}.xlsx`;
    FileSaver.saveAs(data, fileName);
  }

  formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = ('0' + (date.getMonth() + 1)).slice(-2);
    const d = ('0' + date.getDate()).slice(-2);
    return `${y}-${m}-${d}`;
  }
}
